import * as React from 'react'
import * as Redux from 'react-redux'
import styled from 'styled-components'

import { t } from '@owl-nest/localize'
import * as models from '@owl-nest/models'
import { glyphs, Link, styles as S } from '@ulule/owl-kit-components/next'
import * as env from '@owl-nest/config'

import * as projectModel from '../../../../../models/project'
import { RootState } from '../../../../../../reducers'
import { CreateButton } from '../../../components/CreateButton'
import * as UFE from '../../../../../../UFE'
import { EditButton } from '../../../components/EditButton'

import * as Styles from '../../../style'
import * as ProjectTabStyles from '../style'
import { RewardList } from './RewardList'

type RewardsProps = {
  editMode: boolean
  onAdviceClick: () => void
}

const LargeAdviceLinkWrapper = styled(S.copy.S)`
  margin: 5px auto;
`

export function Rewards({ editMode, onAdviceClick }: RewardsProps): React.ReactElement<RewardsProps> {
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)

  const rewardsHelperUrl = models.i18n.get(UFE.LINKS.rewardsHelper)
  const projectIsDonationBased = models.project.isDonationBased(project)
  const userConfig = env.useUserEnv()

  if (editMode && project.rewards === null) {
    return (
      <ProjectTabStyles.CreateButtonWrapper large={true}>
        <CreateButton
          center={true}
          createHandler={() => {
            document.location.href = `/projects/${project.id}/backoffice/rewards/`
          }}
          direction={'column'}
          mode="small"
          title={<S.heading.XS>{t('Add a reward')}</S.heading.XS>}
          cta={
            <LargeAdviceLinkWrapper>
              <Link
                tinted
                withIcon
                onClick={() => {
                  if (userConfig.lang === 'fr') {
                    onAdviceClick()
                  } else {
                    document.location.href = `${rewardsHelperUrl}`
                  }
                }}
              >
                <glyphs.stroke.Bulb size={15} />
                {t('How to create great rewards')}
              </Link>
            </LargeAdviceLinkWrapper>
          }
        />
      </ProjectTabStyles.CreateButtonWrapper>
    )
  }

  return (
    <Styles.SidebarItem forceBorder={true}>
      {!projectIsDonationBased && (
        <>
          <Styles.SidebarHeading>
            <S.heading.M as="h2">{t('Rewards')}</S.heading.M>
            <S.copy.M>{t('Back project and receive exclusive rewards.')}</S.copy.M>
          </Styles.SidebarHeading>
          {editMode && (
            <ProjectTabStyles.EditButtonWrapper>
              <EditButton link={`/projects/${project.id}/backoffice/rewards/`} />
            </ProjectTabStyles.EditButtonWrapper>
          )}
        </>
      )}
      <RewardList />
    </Styles.SidebarItem>
  )
}
